import { heroHighlights, siteStats } from "@/mocks/shows";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-28 pb-14 md:pt-32 md:pb-20">
      <div className="pointer-events-none absolute -right-24 top-10 h-80 w-80 rounded-full bg-accent-200/40 blur-3xl animate-soft-pulse"></div>
      <div className="pointer-events-none absolute -left-32 bottom-0 h-72 w-72 rounded-full bg-primary-100/50 blur-3xl"></div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 md:px-6 lg:grid-cols-2 lg:gap-14">
        <div className="animate-float-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700">
            <i className="ri-tv-line text-primary-600"></i>
            影视剧集一站浏览 · 更新日历清晰可见
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[2.7rem] md:leading-[1.2]">
            大师兄影视
            <span className="mt-1 block text-primary-600">
              在线观看，免费追剧，高清观影
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-600 md:text-base">
            这里把「在线观看、免费追剧、高清观影、全集观看」这几件最常被问到的事集中整理在同一页。
            你可以先看热播推荐快速锁定一部剧，再按更新日历安排追剧节奏，最后按网络情况挑一档合适的清晰度，
            让每一次打开页面都能直接进入正片，而不是在列表里反复翻找。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-lg"></i>
              查看热播推荐
            </a>
            <a
              href="#new"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-700"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              今天更新了什么
            </a>
          </div>

          <ul className="mt-8 grid gap-2.5 sm:grid-cols-2">
            {heroHighlights.map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill mt-0.5 text-base text-accent-500"></i>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="relative animate-float-up">
          <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <div className="aspect-[9/10] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20collage%20of%20Chinese%20drama%20and%20film%20scenes%2C%20amber%20and%20crimson%20lighting%2C%20film%20reel%20and%20theater%20curtain%20texture%2C%20moody%20high%20contrast%2C%20premium%20editorial%20poster%20art%2C%20rich%20shadows%2C%20elegant%20composition%2C%20high%20detail&width=900&height=1000&seq=hero-cinema-01&orientation=squarish"
                alt="大师兄影视热播剧集与影片的综合展示画面"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent p-5">
              <p className="text-xs text-background-100/90">本周热播 · 编辑精选</p>
              <p className="mt-1 font-heading text-lg font-bold text-background-50">
                长风渡月 · 雾港迷案 · 星轨之外
              </p>
            </div>
          </div>

          <div className="absolute -left-4 bottom-8 hidden rounded-xl border border-background-200 bg-background-50 px-4 py-3 sm:block">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-hd-line text-xl"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">画质档位</p>
                <p className="text-sm font-semibold text-foreground-950">标清 / 高清 / 蓝光</p>
              </div>
            </div>
          </div>

          <div className="absolute -right-3 top-8 hidden rounded-xl border border-background-200 bg-background-50 px-4 py-3 sm:block">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className="ri-group-line text-xl"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">收藏剧集</p>
                <p className="text-sm font-semibold text-foreground-950">12,800+ 部</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mx-auto mt-12 max-w-7xl px-4 md:mt-16 md:px-6">
        <div className="grid grid-cols-2 gap-3 rounded-2xl border border-background-200 bg-background-100/70 p-4 md:grid-cols-4 md:gap-4 md:p-6">
          {siteStats.map((stat) => (
            <div key={stat.id} className="flex items-center gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {stat.value}
                </p>
                <p className="text-xs text-foreground-500 md:text-sm">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}